import ElementList from '../../AccountMapperNew/components/ElementList'
import { faPlusCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Col, Row } from 'react-bootstrap'
import React from 'react'

const UserAllocationSelection = ({
  sorElements,
  updateAllocation,
  allocation,
  selectedElementLevel,
  removeGrants,
  addMoreGrants,
  index,
  selectedElementsLength
}) => {
  const element1List = sorElements?.elementList1
  const element2List = allocation.element1
    ? sorElements.elementList2.filter((el) => el.element1Id === allocation.element1.id)
    : []
  const element3List = allocation.element2
    ? sorElements.elementList3.filter((el) => el.element2Map === allocation.element2.element2Map)
    : []
  const element4List = allocation.element3
    ? sorElements.elementList4.filter((el) => el.element3Map === allocation.element3.element3Map)
    : []

  const onElementChange = (eventKey) => {
    const updatedAllocation = allocation
    const e = JSON.parse(eventKey)
    updatedAllocation[e.type] = e
    if (e.type === 'element1') {
      updatedAllocation.element2 && delete updatedAllocation.element2
      updatedAllocation.element3 && delete updatedAllocation.element3
      updatedAllocation.element4 && delete updatedAllocation.element4
    }
    if (e.type === 'element2') {
      updatedAllocation.element3 && delete updatedAllocation.element3
      updatedAllocation.element4 && delete updatedAllocation.element4
    }

    if (e.type === 'element3') {
      updatedAllocation.element4 && delete updatedAllocation.element4
    }
    updateAllocation(updatedAllocation)
  }

  return (
    <Row className="elements-list">
      <Col>
        <ElementList
          id={'element1ForIndex'}
          elementType="element1"
          elements={element1List}
          onChange={onElementChange}
          dropDownLabel={(allocation.element1 && allocation.element1.value) || 'please select'}
        />
      </Col>
      <Col>
        {selectedElementLevel > 1 && (
          <ElementList
            id={'element2ForIndex'}
            elementType="element2"
            elements={element2List}
            onChange={onElementChange}
            dropDownLabel={(allocation.element2 && allocation.element2.value) || 'please select'}
          />
        )}
      </Col>
      <Col>
        {selectedElementLevel > 2 && (
          <ElementList
            id={'element3ForIndex'}
            elementType="element3"
            elements={element3List}
            onChange={onElementChange}
            dropDownLabel={(allocation.element3 && allocation.element3.value) || 'please select'}
          />
        )}
      </Col>
      <Col>
        {selectedElementLevel > 3 && (
          <ElementList
            id={'element4ForIndex'}
            elementType="element4"
            elements={element4List}
            onChange={onElementChange}
            dropDownLabel={(allocation.element4 && allocation.element4.value) || 'please select'}
          />
        )}
      </Col>
      <Col md={1}>
        {allocation.index !== 0 && (
          <button type="button" className="remove-icon" onClick={() => removeGrants(allocation)}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </button>
        )}
        {index === selectedElementsLength - 1 && (
          <button type="button" className="add-more-icon" onClick={addMoreGrants}>
            <FontAwesomeIcon icon={faPlusCircle} />
          </button>
        )}
      </Col>
    </Row>
  )
}

UserAllocationSelection.propTypes = {}

export default UserAllocationSelection
